class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    // Delegado sobre el propio <details-modal>: si el tema o una app vuelve a
    // pintar la cabecera y sustituye el <summary>, el clic sigue funcionando.
    this.addEventListener('click', this.onDelegatedClick.bind(this));

    this.addEventListener('keyup', (event) => {
      if (event.code && event.code.toUpperCase() === 'ESCAPE') this.close();
    });

    if (this.summaryToggle) this.summaryToggle.setAttribute('role', 'button');
  }

  get details() {
    return this.querySelector('details') || this.detailsContainer;
  }

  get summary() {
    return this.querySelector('summary') || this.summaryToggle;
  }

  isOpen() {
    const details = this.details;
    return !!details && details.hasAttribute('open');
  }

  onDelegatedClick(event) {
    const closeButton = event.target.closest && event.target.closest('button[type="button"]');
    if (closeButton && this.contains(closeButton)) {
      event.preventDefault();
      this.close();
      return;
    }

    const summary = event.target.closest && event.target.closest('summary');
    if (!summary || !this.contains(summary)) return;

    event.preventDefault();
    this.isOpen() ? this.close() : this.open();
  }

  onBodyClick(event) {
    // Solo cerramos con clics reales de la persona.
    // La barra de promociones (script en layout/theme.liquid) simula un clic en
    // su flecha "siguiente" cada 5 segundos; ese clic burbujeaba hasta el body y
    // cerraba el buscador solo a los pocos segundos de abrirlo.
    if (event.isTrusted === false) return;

    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open() {
    const details = this.details;
    if (!details || details.hasAttribute('open')) return;

    details.setAttribute('open', true);
    document.body.classList.add('overflow-hidden');

    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    // En el siguiente tick: si no, el mismo clic que abre burbujea hasta el body
    // y puede cerrarlo al instante (el buscador "no responde" al primer clic).
    setTimeout(() => document.body.addEventListener('click', this.onBodyClickEvent), 0);

    const focusTarget = details.querySelector('[tabindex="-1"]');
    const focusInput = details.querySelector('input:not([type="hidden"])');
    if (typeof trapFocus === 'function' && focusTarget) {
      try {
        trapFocus(focusTarget, focusInput);
      } catch (e) {
        /* nunca dejamos la tienda bloqueada por un fallo de foco */
      }
    }
  }

  close(focusToggle = true) {
    const details = this.details;

    try {
      if (typeof removeTrapFocus === 'function') removeTrapFocus(focusToggle ? this.summary : null);
    } catch (e) {
      /* seguimos cerrando pase lo que pase */
    }

    if (details) details.removeAttribute('open');
    if (this.onBodyClickEvent) document.body.removeEventListener('click', this.onBodyClickEvent);
    DetailsModal.releaseScrollIfIdle();
  }

  // Red de seguridad: si no queda ningun modal abierto, la pagina tiene que
  // poder hacer scroll. Evita que la tienda se quede "pillada" si algo cierra
  // el buscador sin pasar por close().
  static releaseScrollIfIdle() {
    const anyOpen = document.querySelector('details-modal details[open], .menu-drawer-container[open], details[open] .menu-drawer');
    if (!anyOpen) document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);

// Vigilante global: si el <details> se cierra por cualquier via (navegacion
// atras, una app, el toggle nativo del navegador), devolvemos el scroll.
document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver(() => DetailsModal.releaseScrollIfIdle());
  document.querySelectorAll('details-modal details').forEach((el) => {
    observer.observe(el, { attributes: true, attributeFilter: ['open'] });
  });
});

window.addEventListener('pageshow', () => DetailsModal.releaseScrollIfIdle());
window.addEventListener('popstate', () => DetailsModal.releaseScrollIfIdle());
document.addEventListener('visibilitychange', () => {
  if (!document.hidden) DetailsModal.releaseScrollIfIdle();
});
